export const Rightarr = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11 9.41421L13.5858 12L11 14.5858V9.41421Z" fill="#242424" stroke="#64748B" strokeWidth="2" />
  </svg>
);
